import { defineStore } from 'pinia'
import { ElMessage } from 'element-plus'
import http from '@/utils/request'

export const useUserStore = defineStore('user', {
  state: () => ({
    // 用户信息
    userInfo: null,
    userId: '',
    // 当前登录手机号（登录时保存）
    carrierPhone: '',
    // 加载状态
    loading: false
  }),

  getters: {
    // 获取用户名称（承运方为承运商名称）
    userName: (state) => state.userInfo?.CarrierName || state.userInfo?.UserName || state.userInfo?.name || '',
    userInfoId: (state) => state.userInfo?.Id || '',
    userAvatar: (state) => state.userInfo?.UserAvatarURL || '',
    // 是否已登录（有用户信息）
    isLoggedIn: (state) => !!state.userInfo
  },

  actions: {
    /**
     * 获取用户信息
     * @returns {Promise}
     */
    async getUserInfo() {
      this.loading = true
      try {
        const res = await http.post('/api/CarrierAuth/GetCarrierTenants')
        if (res.Success) {
          this.userInfo = res.Data

          // 可选：将用户信息保存到 localStorage
          if (res.Data) {
            localStorage.setItem('userInfo', JSON.stringify(res.Data || null))
          }
          return res.Data
        } else {
          ElMessage.error(res.Msg || '获取用户信息失败')
          return null
        }
      } catch (error) {
        console.error('获取用户信息失败:', error)
        ElMessage.error(error.message || '获取用户信息失败')
        return null
      } finally {
        this.loading = false
      }
    },

    /**
     * 设置当前登录手机号
     * @param {String} phone
     */
    setCarrierPhone(phone) {
      this.carrierPhone = phone || ''
      localStorage.setItem('carrierPhone', this.carrierPhone)
    },

    /**
     * 设置用户信息
     * @param {Object} userInfo - 用户信息对象
     */
    setUserInfo(userInfo) {
      this.userInfo = userInfo
      if (userInfo) {
        localStorage.setItem('userInfo', JSON.stringify(userInfo))
      }
    },

    /**
     * 清除用户信息（退出登录时使用）
     */
    clearUserInfo() {
      this.userInfo = null
      this.carrierPhone = ''
      localStorage.removeItem('userInfo')
      localStorage.removeItem('carrierPhone')
    },

    /**
     * 从 localStorage 恢复用户信息
     */
    restoreUserInfo() {
      this.carrierPhone = localStorage.getItem('carrierPhone') || ''
      try {
        const userInfoStr = localStorage.getItem('userInfo')
        if (userInfoStr) {
          this.userInfo = JSON.parse(userInfoStr)
        }
      } catch (error) {
        console.error('恢复用户信息失败:', error)
        this.userInfo = null
      }
    }
  }
})
